module.exports = __webpack_public_path__ + "static/media/health_question.f41a4aad.mp3";